// Triggering rebuild
/* eslint-disable react/prop-types */
import { useEffect, useState, useCallback } from "react";

import Card from "@mui/material/Card";
import { formatDate } from "utils";
import SoftBox from "components/SoftBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell/index";
import { JournalVoucher8Service } from "services/journal-voucher-8";
import { CompanyService } from "services/companyService";
import toast from "react-hot-toast";

const currentYear = String(new Date().getFullYear());
const currentMonth = String(new Date().getMonth() + 1);

const renderData = (items, setDataTable) => {
  return items.map((item) => {
    return {
      id: item._id,
      unit: item.unit || "",
      month: item.month || "",
      year: item.year || "",
      ledgerClerk: item.ledgerClerk || "",
      createdAt: formatDate(item.createdAt),
      action: <ActionCell item={item} setDataTable={setDataTable} />,
    };
  });
};

const tableData = {
  columns: [
    { Header: "Đơn vị", accessor: "unit", width: "35%" },
    { Header: "Tháng", accessor: "month", width: "10%" },
    { Header: "Năm", accessor: "year", width: "10%" },
    { Header: "Người ghi sổ", accessor: "ledgerClerk", width: "20%" },
    { Header: "Ngày tạo", accessor: "createdAt", width: "15%" },
    { Header: "Thao tác", accessor: "action", sorted: false },
  ],
  rows: [],
};

function JournalVoucher8() {
  const [companyId, setCompanyId] = useState("");
  const [loading, setLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [filters, setFilters] = useState({
    year: currentYear,
    month: currentMonth,
    searchBy: "",
  });
  const [query, setQuery] = useState({
    year: currentYear,
    month: currentMonth,
    sortBy: "createdAt",
    sortType: "desc",
  });
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 10,
  });

  useEffect(() => {
    const init = async () => {
      try {
        const response = await CompanyService.getByAuth();
        const payload = response?.data || response || {};
        setCompanyId(payload?._id || "");
      } catch (error) {
        console.error("Lỗi lấy thông tin công ty:", error);
      }
    };
    init();
  }, []);

  const fetchData = useCallback(async () => {
    if (!companyId) return;
    try {
      setLoading(true);

      const response = await JournalVoucher8Service.getPaginate({
        ...query,
        company: companyId,
        page: paginationData.page,
        size: paginationData.size,
      });

      const { items, paginate } = response.data || response;
      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items || [], setDataTable),
      }));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Lỗi lấy dữ liệu Nhật ký chứng từ số 8 (S04a8-DN):", error);
      setDataTable((prev) => ({ ...prev, rows: [] }));
    }
  }, [companyId, query, paginationData.page, paginationData.size]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSync = async () => {
    if (!companyId || !filters.year || !filters.month) {
      toast.error("Thiếu thông tin công ty, năm hoặc tháng");
      return;
    }
    try {
      setSyncing(true);
      await JournalVoucher8Service.sync({
        company: companyId,
        year: filters.year,
        month: filters.month,
      });

      toast.success("Đồng bộ dữ liệu thành công");
      setQuery((prev) => ({ ...prev, ...filters }));
      setPaginationData((prev) => ({ ...prev, page: 1 }));
      fetchData();
    } catch (error) {
      console.error("Lỗi đồng bộ Nhật ký chứng từ số 8:", error);
      toast.error(error.response?.data?.message || "Lỗi đồng bộ dữ liệu");
    } finally {
      setSyncing(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            filters={filters}
            setFilters={setFilters}
            query={query}
            setQuery={setQuery}
            table={dataTable}
            loading={loading}
            syncing={syncing}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
            onSync={handleSync}
            onFetchData={(newFilters) => {
              setQuery((prev) => ({ ...prev, ...newFilters }));
              setPaginationData((prev) => ({ ...prev, page: 1 }));
            }}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default JournalVoucher8;
